var _style, _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWonderlicLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wonderlic_logo_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "100.88 91.47 584.32 92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".wonderlic_logo_svg__st00,.wonderlic_logo_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#2a2f3c}.wonderlic_logo_svg__st1{fill:url(#wonderlic_logo_svg__SVGID_1_)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_logo_svg__st00",
    d: "M314.2 131.8l14.1 37.5 19.4-51.7h-6.6l-12.7 34.2-14.1-37.5-14.1 37.5-12.8-34.2h-6.6l19.4 51.7 14-37.5zm45.6 28.4c2.4 2.4 5.1 4.3 8.1 5.5s6.2 1.8 9.7 1.8 6.7-.6 9.7-1.8 5.6-3 8.1-5.5c2.4-2.4 4.3-5.2 5.5-8.3s1.8-6.4 1.8-10.1c0-3.6-.6-7-1.8-10-1.2-3-3-5.8-5.5-8.2-2.4-2.4-5.1-4.3-8.1-5.5-3-1.2-6.2-1.9-9.7-1.9s-6.7.6-9.7 1.9c-2.9 1.2-5.6 3.1-8.1 5.5-2.4 2.4-4.3 5.2-5.5 8.2s-1.8 6.4-1.8 10c0 3.6.6 7 1.8 10.1 1.2 3.1 3 5.8 5.5 8.3zm4.7-31.9c1.7-1.8 3.7-3.2 5.8-4.1 2.2-.9 4.6-1.4 7.2-1.4s5 .4 7.2 1.4c2.2.9 4.1 2.3 5.8 4.1 1.7 1.8 3 3.8 3.9 6 .9 2.3 1.3 4.8 1.3 7.5s-.4 5.2-1.3 7.5c-.8 2.3-2.1 4.3-3.9 6.1-1.7 1.8-3.7 3.1-5.8 4-2.2.9-4.6 1.4-7.2 1.4s-5-.4-7.2-1.4c-2.2-.9-4.1-2.2-5.8-4-1.7-1.8-3-3.9-3.9-6.1-.9-2.3-1.3-4.8-1.3-7.5s.4-5.2 1.3-7.5c.9-2.2 2.2-4.2 3.9-6zm53.6 37.7v-28.9c0-2.7.6-5.1 1.7-7.1s2.7-3.6 4.7-4.8c2-1.2 4.3-1.7 7-1.7 2.5 0 4.7.5 6.6 1.6s3.3 2.6 4.3 4.5c1 2 1.5 4.3 1.5 7V166h6.9v-30.9c0-3.7-.7-6.9-2.2-9.6-1.4-2.7-3.4-4.8-6-6.3s-5.7-2.3-9.3-2.3c-2.4 0-4.6.4-6.5 1.1-2 .7-3.7 1.8-5.1 3.1-1.5 1.3-2.6 2.9-3.5 4.7v-8.2h-6.9V166h6.8zm64.6-49.8c-3.3 0-6.4.6-9.2 1.9-2.8 1.2-5.4 3.1-7.7 5.5s-4 5.2-5.2 8.2-1.7 6.4-1.7 10c0 3.6.6 7 1.7 10.1 1.2 3.1 2.9 5.8 5.2 8.3 2.3 2.4 4.9 4.3 7.7 5.5 2.8 1.2 5.9 1.8 9.2 1.8 2.8 0 5.3-.4 7.5-1.2 2.2-.8 4-1.8 5.6-3.1 1.5-1.3 2.7-2.8 3.6-4.4v7.2h6.9V99.1h-6.9v25.7c-.9-1.6-2.1-3.1-3.6-4.4-1.5-1.3-3.4-2.3-5.6-3.1-2.1-.7-4.6-1.1-7.5-1.1zm0 44.6c-2.4 0-4.7-.4-6.7-1.4-2-.9-3.9-2.2-5.5-4s-2.8-3.9-3.6-6.1c-.8-2.3-1.2-4.8-1.2-7.5 0-5.5 1.6-10 4.8-13.5 1.6-1.8 3.5-3.2 5.5-4.1 2-.9 4.2-1.4 6.7-1.4s4.8.4 6.9 1.4c2.1.9 4 2.3 5.6 4.1 3.4 3.6 5.1 8.1 5.1 13.5 0 2.7-.4 5.2-1.3 7.5-.8 2.3-2.1 4.3-3.8 6.1-1.6 1.8-3.5 3.1-5.6 4-2 1-4.3 1.4-6.9 1.4zm32.3-18.4c0 3.7.5 7.1 1.6 10.1s2.7 5.6 4.9 7.9 4.7 4 7.6 5.1c2.9 1.1 6.1 1.7 9.6 1.7 3.9 0 7.4-.7 10.6-2.1 3.2-1.4 6-3.6 8.5-6.4l-4.6-4.6c-1.4 1.5-2.8 2.8-4.2 3.8s-2.9 1.7-4.6 2.2-3.6.7-5.7.7c-3.3 0-6.2-.7-8.6-2.2-2.5-1.4-4.4-3.4-5.8-6-1.4-2.6-2.2-5.7-2.4-9.3h38.2c0-.5.1-1 .1-1.5v-1.6c0-3.4-.5-6.5-1.5-9.4-1-2.8-2.5-5.4-4.6-7.7-2-2.4-4.3-4.1-6.9-5.3-2.6-1.2-5.5-1.7-8.7-1.7-3.4 0-6.5.6-9.4 1.8-2.8 1.2-5.4 3-7.6 5.3-2.2 2.4-3.9 5.1-5 8.2-1.1 3.1-1.7 6.6-1.7 10.5v.5h.2zm7.4-5.3c.3-3.9 2-7.3 5.1-10.1 1.5-1.4 3.2-2.4 5.1-3.2 1.9-.7 3.9-1.1 6-1.1 2 0 3.8.4 5.5 1.1 1.7.7 3.2 1.8 4.6 3.2 2.8 2.8 4.2 6.1 4.2 10.1h-30.5zm53.1 28.9v-28.1c0-2.7.6-5.1 1.7-7.1s2.6-3.6 4.5-4.8c1.9-1.2 4.1-1.7 6.6-1.7.9 0 1.8 0 2.6.1s1.5.2 2.1.4v-7.7c-.4 0-.9-.1-1.4-.1s-1-.1-1.5-.1c-2.3 0-4.4.4-6.2 1.1-1.9.7-3.5 1.8-4.9 3.1-1.4 1.3-2.5 2.9-3.4 4.7v-8.2h-6.9V166h6.8zm26.9-12.2c0 2.9.4 5.4 1.2 7.3.8 2 1.9 3.3 3.4 4.2.9.5 1.9 1 2.7 1.3.9.3 1.7.5 2.6.6.9.1 1.9.2 2.9.2.6 0 1.2 0 1.7-.1.6-.1 1.1-.2 1.6-.3v-6.6l-1.5.3c-.6 0-1.2.1-1.8.1-1.4 0-2.6-.2-3.5-.8-.9-.5-1.5-1.3-1.9-2.4-.4-1.1-.6-2.5-.5-4.3V99.1h-6.9v54.7zm31.1-45.6c.6-.7 1-1.4 1.2-2.2.2-.8.2-1.6 0-2.5-.2-.8-.6-1.5-1.2-2.1-.6-.6-1.3-1.1-2.1-1.3-.8-.2-1.5-.2-2.3 0-.8.2-1.5.6-2.1 1.3-.6.6-1 1.3-1.2 2.1-.2.8-.2 1.6 0 2.5.2.8.6 1.6 1.2 2.2.6.6 1.3 1 2.1 1.2.8.2 1.5.2 2.3 0 .7-.2 1.4-.6 2.1-1.2zm.2 57.8v-48.4h-6.9V166h6.9zm33.7-49.8c-3.5 0-6.7.6-9.7 1.9-2.9 1.2-5.6 3.1-8.1 5.5-2.4 2.4-4.3 5.2-5.5 8.2s-1.8 6.4-1.8 10c0 3.6.6 7 1.8 10.1 1.2 3.1 3 5.8 5.5 8.3 2.4 2.4 5.1 4.3 8.1 5.5s6.2 1.8 9.7 1.8c3.6 0 7-.6 9.9-1.8 3-1.2 5.6-3 7.9-5.5l-4.2-5c-1.8 1.9-3.8 3.3-6.1 4.2s-4.8 1.4-7.6 1.4c-2.6 0-5-.4-7.2-1.4-2.2-.9-4.1-2.2-5.8-4s-3-3.9-3.9-6.1c-.9-2.3-1.3-4.8-1.3-7.5s.4-5.2 1.3-7.5c.8-2.3 2.1-4.3 3.9-6 1.7-1.8 3.7-3.2 5.8-4.1 2.2-.9 4.6-1.4 7.2-1.4 2.8 0 5.3.5 7.6 1.4 2.3 1 4.3 2.4 6.1 4.2l4.2-5c-2.3-2.4-4.9-4.3-7.9-5.5-2.9-1.1-6.2-1.7-9.9-1.7z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.633,
    y1: 250.812,
    x2: 277.765,
    y2: 158.491,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wonderlic_logo_svg__st1",
    d: "M263.1 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000147905200493889249270000017005875678305300112_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.788,
    y1: 232.045,
    x2: 260.92,
    y2: 139.724,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8-11.9-6.5-11.5-13.5c.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000147905200493889249270000017005875678305300112_)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000042695224951767566060000006590544811305081985_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.051,
    y1: 194.461,
    x2: 227.184,
    y2: 102.14,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8-11.9-6.5-11.5-13.5c.5-7 6.3-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000042695224951767566060000006590544811305081985_)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000158733546888851492920000001850286779785926332_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.16,
    y1: 175.644,
    x2: 210.293,
    y2: 83.323,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.1 91.5c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000158733546888851492920000001850286779785926332_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000086693476394935205890000009015949591025969549_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.344,
    y1: 211.588,
    x2: 240.982,
    y2: 116.957,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1 181.1c-5.1-3.9-6.1-11.2-2.3-16.4l32.8-44.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-32.8 44.9c-3.8 5.3-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000086693476394935205890000009015949591025969549_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000163066624657800662710000001146603861527874205_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.774,
    y1: 201.677,
    x2: 233.32,
    y2: 108.053,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9 159.1c-5.1-3.9-6.1-11.2-2.3-16.4l16.7-22.9c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-16.7 23c-3.8 5.2-11 6.2-16 2.3z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000163066624657800662710000001146603861527874205_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000110472522487153581690000010430319036875975079_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.946,
    y1: 169.095,
    x2: 204.756,
    y2: 76.149,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 146.5c-5.1-3.9-6.1-11.2-2.3-16.4l7.5-10.3c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-7.5 10.3c-3.8 5.3-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000110472522487153581690000010430319036875975079_)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000181772016274277004400000011995321889518572162_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.88,
    y1: 195.395,
    x2: 228.012,
    y2: 103.075,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 111.1c6.8.5 12 6.5 11.5 13.5s-6.4 12.3-13.2 11.8c-6.8-.5-11.9-6.5-11.5-13.5.5-7 6.4-12.3 13.2-11.8z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000181772016274277004400000011995321889518572162_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wonderlic_logo_svg__SVGID_00000103264121400252128790000005978306301823534505_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.997,
    y1: 163.664,
    x2: 199.679,
    y2: 69.915,
    gradientTransform: "matrix(1 0 0 -1 0 277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 181.1c-5.1-3.9-6.1-11.2-2.3-16.4l18.5-25.4c3.8-5.2 11-6.2 16-2.4 5.1 3.9 6.1 11.2 2.3 16.4l-18.5 25.4c-3.7 5.3-10.9 6.3-16 2.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#wonderlic_logo_svg__SVGID_00000103264121400252128790000005978306301823534505_)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWonderlicLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wonderlic_logo.be45b47302f18405f0072dd806509d68.svg";